import b from 'b_';
import React from 'react';
import SimpleMarkdown, { SingleNodeParserRule, ReactOutputRule, SingleASTNode } from 'simple-markdown';

import LibraryBanner, {
    OwnProps as LibraryBannerProps,
    LIBRARY_BANNER_THEME,
} from 'common.components/library-banner/library-banner';

interface ConfigItem extends LibraryBannerProps {}

export interface LibraryBannersConfig {
    theme?: LIBRARY_BANNER_THEME;
    items: ConfigItem[];
}

interface LibraryBannersConfigNode extends SingleASTNode {
    config: LibraryBannersConfig;
}

function isLibraryBannersConfigNode(node: SingleASTNode): node is LibraryBannersConfigNode {
    return node.config && Array.isArray(node.config.items);
}

export const libraryBannersRule: { libraryBanners: SingleNodeParserRule & ReactOutputRule } = {
    libraryBanners: {
        order: 0,
        // {libraryBanners}JSON-STRING{/libraryBanners}
        match: SimpleMarkdown.inlineRegex(/^\{libraryBanners\}(.*?)\{\/libraryBanners\}/),
        parse(capture) {
            try {
                const config: LibraryBannersConfig = JSON.parse(capture[1]);

                return {
                    config,
                };
            } catch (e) {
                console.error(e);
                return {
                    config: { items: [] },
                };
            }
        },
        react(node) {
            const config: LibraryBannersConfig = isLibraryBannersConfigNode(node) ? node.config : { items: [] };

            return <RuleComponent config={config} />;
        },
    },
};

const RuleComponent = ({ config }: { config: LibraryBannersConfig }) => {
    return (
        <div className={b('library-banners-wrapper', { theme: config.theme })}>
            {config.items.map((item) => (
                <LibraryBanner {...item} key={item.imageUrl} />
            ))}
        </div>
    );
};
